import React from 'react';
import cx from 'classnames';

export default class extends React.Component {
  static displayName = 'Icon';

  render() {
    var cssClasses = {};
    cssClasses['Icon'] = true;
    cssClasses['t-' + this.props.theme] = !!this.props.theme;

    var iconWrapperClasses = cx(cssClasses);

    return (
      <span className={iconWrapperClasses}>
        <span className={'af-icon af-' + this.props.icon}></span>
      </span>
    );
  }
}
